export const ctaCopy = {
  'default.personal-loan': { ad: 'Personal loans starting at 4.9% APR.', cta: 'Apply Inside' },
  'default.business-credit': { ad: 'Business lines of credit for small operators.', cta: 'Apply Inside' },
  'default.agricultural': { ad: 'Agricultural loans built for the harvest.', cta: 'Apply Inside' },
  'triggered.tornado': { ad: 'Take shelter immediately.', cta: '' },
  'triggered.multiple_people': { ad: 'Open a new credit card and take your family on vacation.', cta: 'Apply Inside' },
  'triggered.single_female': { ad: 'That purse, on us — 0% interest for 6 months.', cta: 'Apply Inside' },
  'triggered.single_male': { ad: 'Auto loans from 0.9% for qualified buyers.', cta: 'Apply Inside' },
} as const;

export type CtaKey = keyof typeof ctaCopy;
